import React from 'react';

/**
 * Compact KPI tiles for O/D Analytics.
 *
 * Each tile: { key, label, value, unit, sub, tone }
 * `tone` is one of 'warn' | 'bad' | 'ok' and only colours the sub line — the value stays
 * neutral so a wall of tiles doesn't read as a wall of alerts.
 */
const OdKpiRow = (props) => {
    const { tiles } = props;
    const visible = (tiles || []).filter(Boolean);
    if (visible.length === 0) return null;

    return (
        <div className="od-kpi-row">
            {visible.map((tile) => (
                <div className="od-kpi" key={tile.key}>
                    <div className="od-kpi-label">{tile.label}</div>
                    <div className="od-kpi-value">
                        {tile.value}
                        {tile.unit && <span className="od-kpi-unit">{tile.unit}</span>}
                    </div>
                    {tile.sub && (
                        <div className={`od-kpi-sub${tile.tone ? ` od-kpi-sub-${tile.tone}` : ''}`}>
                            {tile.sub}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default OdKpiRow;
